// extracted by mini-css-extract-plugin
export default {"button":"fv","primary":"gv","fullWidth":"hv","secondary":"iv","nutrition":"jv","underlined":"kv","small":"lv","medium":"mv","info":"nv","white":"ov","border":"pv","mango":"qv","charcoal":"rv","court":"sv","green":"tv","spark":"uv","linkButton":"vv","disabled":"wv"};
    if(module.hot) {
      // 1738064238253
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  